import { useLayoutEffect, useRef, useState } from "react";
import { InvoicePreview } from "../../../InvoicePage";

/**
 * «عرض السعر» لعرض مرتبط بفاتورة مشروع أو تسعيرة: نفس تصميم وترتيب الفاتورة
 * الأصلية بالضبط - نفس مكوّن معاينة الفاتورة (InvoicePreview بـInvoicePage.jsx)
 * اللي تنصنع منه صورة الفاتورة وملفها، فأي تعديل على تصميم الفاتورة ينعكس هنا.
 *
 * بنفس القياسات بالضبط (1200px بدون تكبير/تصغير) بنص صفحة العرض (1500 ×
 * 1080px = 1125 × 810pt). إذا طالت تكمل على الصفحة اللي بعدها، والقطع يصير
 * بين السطور/الأقسام (مو بنص سطر).
 */
const PAGE_W = 1500;
const PAGE_H = 1080;
const INVOICE_W = 1200;
const MARGIN_X = (PAGE_W - INVOICE_W) / 2;
const MARGIN_Y = 40;
const PAGE_CONTENT_H = PAGE_H - 2 * MARGIN_Y;
// صفحة ما تنقطع قبل هالطول حتى لو ماكو نقطة قطع (ما نسوي صفحات فارغة تقريباً)
const MIN_PAGE_FILL = 200;

// أماكن القطع الممكنة: بداية كل سطر جدول وكل قسم من الفاتورة (بالبكسل من فوك)
const breakPoints = (root) => {
    const top = root.getBoundingClientRect().top;
    const points = new Set();
    root.querySelectorAll("tr, :scope > div, table, img").forEach((el) => {
        points.add(Math.round(el.getBoundingClientRect().top - top));
    });
    return [...points].sort((a, b) => a - b);
};

// يقسّم طول الفاتورة لصفحات: كل صفحة تنقطع عند آخر نقطة قطع تدخل بيها
export const paginate = (height, points) => {
    const pages = [];
    let start = 0;
    while (start < height) {
        const limit = start + PAGE_CONTENT_H;
        if (limit >= height) {
            pages.push([start, height]);
            break;
        }
        const minEnd = start + MIN_PAGE_FILL;
        const fits = points.filter((y) => y >= minEnd && y <= limit);
        const end = fits.length ? fits[fits.length - 1] : limit;
        pages.push([start, end]);
        start = end;
    }
    return pages.length ? pages : [[0, PAGE_CONTENT_H]];
};

export function InvoicePages({ invoice, wrap }) {
    const measureRef = useRef(null);
    const [pages, setPages] = useState([[0, PAGE_CONTENT_H]]);

    useLayoutEffect(() => {
        const el = measureRef.current;
        if (!el)
            return undefined;
        const measure = () => setPages(paginate(el.offsetHeight, breakPoints(el)));
        measure();
        const ro = new ResizeObserver(measure);
        ro.observe(el);
        // الصور (الشعار/الإطارات) تغيّر الطول بعد ما تحمّل
        el.querySelectorAll("img").forEach((img) => img.addEventListener("load", measure));
        return () => {
            ro.disconnect();
            el.querySelectorAll("img").forEach((img) => img.removeEventListener("load", measure));
        };
    }, [invoice]);

    return (<>
      {/* نسخة مخفية بس لقياس الفاتورة - ما تاخذ مكان ولا تنطبع */}
      <div aria-hidden="true" style={{ height: 0, overflow: "hidden" }}>
        <InvoicePreview ref={measureRef} invoice={invoice}/>
      </div>
      {pages.map(([start, end], k) => wrap(<section className="doc-page doc-invoice-page" dir="rtl" style={{ background: "#ffffff" }}>
            <div style={{
                position: "absolute",
                left: MARGIN_X,
                top: MARGIN_Y,
                width: INVOICE_W,
                height: end - start,
                overflow: "hidden",
            }}>
              <div style={{ transform: `translateY(${-start}px)` }}>
                <InvoicePreview invoice={invoice}/>
              </div>
            </div>
          </section>, `invoice-${k}`))}
    </>);
}
